/* eslint-disable no-shadow */
const state = {
  cart: []
};

const getters = {
  getCart: state => state.cart
};

const mutations = {
  addToCartMutation: (state, payload) => {
    state.cart = payload;
  }
};

const actions = {
  addToCart: ({ commit }, payload) => {
    commit("addToCartMutation", payload);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
